import { Personalize as UFPersonalize } from "@uniformdev/context-react"
import VideoLauncher from "components/video-launcher/VideoLauncher"

function Variation({ video_cta }) {
  return <VideoLauncher className={video_cta.style || ""} video_player_cld={video_cta} />
}

export default function P13N(props) {
  const variations = props.video_cta.reduce((variations, variation, i) => {
    const {
      criteria: { name: pz = null },
      video_cta,
    } = variation
    !!video_cta && variations.push(Object.assign({ video_cta }, pz && { pz }))
    return variations.sort((a, b) => +!!b?.pz - +!!a?.pz) /** move default variant at the end of the array */
  }, [])

  return <UFPersonalize variations={variations} component={Variation} />
}
